import React, { Fragment, useEffect, useState } from "react";
import useAPI from "hooks/useAPI";
import useBookings from "hooks/useBookings";
import Price from "./components/Price";
import useSelection from "hooks/useSelection";
import { useSelector } from "react-redux";
import { BsXLg } from "react-icons/bs";
import { Animated } from "react-animated-css";
const Cost = ({ bookingId, className }) => {
  const [additional3Surprises, setAdditional3Surprises] = useState(false);
  const { bookingHasBeenPaid } = useBookings();
  const { setSelectionForKey } = useSelection({
    key: "additional3Surprises",
    setter: setAdditional3Surprises,
  });
  const selection = useSelector((state) => {
    return state.booking.selection;
  });

  const booking = useSelector((state) => {
    return state.booking;
  });

  const { getCost } = useBookings({});
  const [cost, setCost] = useState({
    bookingFee: 0,
    additional3Surprises: null,
    vat: 0,
    total: 0,
  });
  const { API } = useAPI({});

  useEffect(() => {
    if (bookingId) {
      getAndSetCost();
    }
  }, [bookingId]);

  useEffect(() => {
    setTimeout(() => {
      getAndSetCost();
    }, 500);
  }, [
    additional3Surprises,
    selection.additional3Surprises,
    selection.discountCode,
    selection.isCorporate,
  ]);

  const getAndSetCost = async () => {
    let costToSet = await getCost(bookingId);
    if (costToSet) {
      setCost(costToSet);
    }
  };

  const CostItem = ({
    name,
    value,
    onClickedRemove,
    className,
    isNegative,
    preNameContent,
  }) => {
    return (
      <div
        className={`grid grid-cols-9 ${className ? className : ""} gap-4 my-2`}
      >
        <div className="text-right col-span-6 ">
          <div className="flex items-center gap-2 justify-end">
            {preNameContent ? preNameContent : null}
            <h5 className="mirum-color-pink">{name}:</h5>
          </div>
        </div>
        <div className="col-span-3">
          <Price
            value={value}
            isNegative={isNegative}
            className="font-black text-black"
          />
          {onClickedRemove && (
            <div className="cursor-pointer inline-block ml-2 ">
              <div
                onClick={onClickedRemove}
                style={{ color: "red", fontSize: "12px" }}
              >
                <BsXLg />
              </div>
            </div>
          )}
        </div>
        {/* <div className="col-span-3 text-left">
          
        </div> */}
      </div>
    );
  };

  return (
    <Fragment>
      {/* {!bookingHasBeenPaid(booking) && ( */}
      <div
        className={`w-full `} //grid grid-cols-3 gap-2 ${className} lowercase place-items-start justify-items-end
      >
        <CostItem name="service fee" value={cost.bookingFee} />
        {cost.additional3Surprises && additional3Surprises === true && (
          <CostItem
            name="additional 3 surprises"
            value={cost.additional3Surprises}
            onClickedRemove={
              !bookingHasBeenPaid(booking)
                ? () => {
                    setSelectionForKey(false);
                  }
                : null
            }
          />
        )}
        {cost.discount && cost.discount > 0 ? (
          <CostItem name="discount" value={cost.discount} isNegative={true} />
        ) : null}
        <CostItem name="VAT" value={cost.vat} />
        <hr />
        <CostItem
          name="total"
          value={cost.total}
          preNameContent={
            !selection.isCorporate &&
            cost.additional3Surprises &&
            additional3Surprises === true && (
              <p className="text-black font-black">
                {/* You are saving <Price value={cost.discount + 400} />! */}
                You are saving{" "}
                <Price
                  value={
                    cost.bookingFee * 4 * 1.2 -
                    (cost.bookingFee + cost.additional3Surprises + cost.vat) +
                    cost.discount
                  }
                />
                !
              </p>
            )
          }
        />

        {/* 
        <div className="text-right">
          <h5 className="mirum-color-pink">Service Fee:</h5>
        </div>
        <div className="col-span-2">
          <Price value={cost.bookingFee} />
        </div>
        {cost.additional3Surprises && additional3Surprises === true && (
          <Fragment>
            <div className="text-right">
              <h5 className="mirum-color-pink">Additional 3 surprises:</h5>
            </div>
            <div>
              <Price value={cost.additional3Surprises} />
            </div>
            <div className="cursor-pointer ">
              <div
                onClick={() => {
                  setSelectionForKey(false);
                }}
              >
                <BsXLg />
              </div>
            </div>
          </Fragment>
        )}
        {cost.discount && cost.discount > 0 ? (
          <Fragment>
            <div className="text-right">
              <h5 className="mirum-color-pink">Discount:</h5>
            </div>
            <div className="col-span-2">
              <Price value={cost.discount} isNegative={true} />
            </div>
          </Fragment>
        ) : null}
        <div className="text-right uppercase">
          <h5 className="mirum-color-pink">VAT:</h5>
        </div>
        <div className="col-span-2">
          <Price value={cost.vat} />
        </div>
        <div className="text-right">
          <h4 className="mirum-color-pink">Total:</h4>
        </div>
        <div className="col-span-2">
          <Price value={cost.total} />
        </div> */}
      </div>
    </Fragment>
  );
};

export default Cost;
